import { styled } from '@mui/material';

import CourseUserCell, { courseUserCellClasses } from '../../../../../components/CourseUserCell';
import { pick } from '../../../../../utils/helpers';

export const userCellClasses = pick(courseUserCellClasses, 'subtitle');

export const StyledCourseUserCell = styled(CourseUserCell)(({ theme }) => ({
  [`& .${userCellClasses.subtitle}`]: {
    color: theme.palette.warning[500],
  },
}));
